import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, icon, trend, trendValue, color = 'primary' }) => {
  const colorClasses = {
    primary: 'bg-primary/10 text-primary',
    success: 'bg-success/10 text-success',
    warning: 'bg-warning/10 text-warning',
    error: 'bg-error/10 text-error'
  };

  const trendColorClasses = {
    up: 'text-success',
    down: 'text-error',
    neutral: 'text-muted-foreground'
  };

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-elevation-sm hover:shadow-elevation-md transition-smooth border border-border">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex-1">
          <p className="text-sm md:text-base text-muted-foreground mb-1 md:mb-2">{title}</p>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground data-text">{value}</h3>
        </div>
        <div className={`${colorClasses?.[color]} p-2 md:p-3 rounded-lg`}>
          <Icon name={icon} size={24} className="md:w-7 md:h-7 lg:w-8 lg:h-8" />
        </div>
      </div>
      {trend && (
        <div className="flex items-center gap-1 md:gap-2">
          <Icon 
            name={trend === 'up' ? 'TrendingUp' : trend === 'down' ? 'TrendingDown' : 'Minus'} 
            size={16} 
            className={`${trendColorClasses?.[trend]} md:w-5 md:h-5`}
          />
          <span className={`text-xs md:text-sm font-medium ${trendColorClasses?.[trend]}`}>
            {trendValue}
          </span>
          <span className="text-xs md:text-sm text-muted-foreground">vs last month</span>
        </div>
      )}
    </div>
  );
};

export default MetricCard;